import ContentsBase from './ContentsBase';
import LegendMSM from '../legend/LegendMSM';
import { formatBaseTime, formatValidTime } from "../../../utils/FPEUtils";
import { WX_ID_MSM } from "../../../store/WeatherContentsState";
import WRAP from 'WRAP-JS';
import TimeController from "../../map/helper/TimeController";
import Msm from "../../map/layers/Msm";

class ModelMSM extends ContentsBase {
  static NAME = WX_ID_MSM;
  static MSM_CHANGE_ALL = 'MSM_change_all';
  static MSM_EQV_PT = 'EqvPT';
  static MSM_ISOTACH = 'Isotach';
  static MSM_ISOTHERM = 'Isotherm';
  static MSM_TMINUS_TD = 'TMinusTD';
  static MSM_VWS = 'VWS';
  static MSM_WIND = 'Wind';
  static MSM_ICING_PROB = 'IcingProb';

  static CS_NAME = `CS_${ModelMSM.NAME}`;
  presetId = ModelMSM.CS_NAME;

  prevValidtime;
  contentsVisibleState = {
    EqvPT: true,
    Isotach: true,
    Isotherm: true,
    TMinusTD: true,
    VWS: true,
    Wind: false,
    IcingProb: true
  };
  setRevision;

  constructor(setRevision) {
    super('MSM', 'MSM', 'Model_MSM');
    this.setRevision = setRevision;
    this.timeController = new TimeController(`CS_${WX_ID_MSM}`, {
      crossSection: true,
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg).then(() => {
          if (this.timeController._parent !== null && autoFlg) {
            this.setRevision();
          }
        });
      }
    });
  }

  addObject() {
    return new Promise((resolve, reject) => {
      this.dataHandler = WRAP.DH.addObject(this.dataConfName);
      this.dataHandler.inspect(function (ref) {
        try {
          if (this._validate(ref)) {
            this.dataReference = ref;
            if(this.dataReference.query("timelist").value()) {
              this.parseTimelist();
              this.ready = true;
              this.updated = true;
              resolve();
            }
          } else {
            this.addErrorMessage('Configuration validate error.');
            reject();
          }
        } catch (e) {
          this._error(e);
          reject();
        }
      }.bind(this), false)
    });
  }

  parseTimelist() {
    const fullList = this.dataReference.query("timelist").value();
    this.validtimeList = this._parseTimelist(fullList);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision()
      }
    }
    this.prevValidtime = JSON.parse(JSON.stringify(this.validtimeList));
  }

  getOpt(date, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(date, fpMode);
        return {
          Model: {
            Basetime: this.shownTime.basetime,
            Element: {
              ...this.contentsVisibleState
            },
            Name: "MSM",
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible()
          }
        }
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: ModelMSM.NAME,
      label: 'MSM',
      component: LegendMSM,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: ModelMSM.NAME,
      label: 'MSM',
      baseTime: this.shownTime ? formatBaseTime(this.shownTime.basetime) : "---",
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
  }

  getTimeControllerInfo() {
    return {
      mapContentsId: WX_ID_MSM,
      timeController: this.timeController
    };
  }

  setContentsSettings(param) {
    Object.keys(param).forEach(k => {
      this.contentsVisibleState[k] = param[k];
    });
  }

  static resolveCsTargetName(targetName) {
    let csTargetName;
    switch(targetName) {
      case Msm.WIND_ARROW_NAME:
        csTargetName = ModelMSM.MSM_WIND;
        break;
      case Msm.ISOTACH_CONTOUR_NAME:
        csTargetName = ModelMSM.MSM_ISOTACH;
        break;
      case Msm.ISOTHERM_CONTOUR_NAME:
        csTargetName = ModelMSM.MSM_ISOTHERM;
        break;
      case Msm.ICING_PROB_NAME:
        csTargetName = ModelMSM.MSM_ICING_PROB;
        break;
      default:
        csTargetName = targetName;
        break;
    }
    return csTargetName;
  }
}

export default ModelMSM;
